if (!customElements.get('upsell-product')) {
  customElements.define(
    'upsell-product',
    class upsellProduct extends HTMLElement {
      constructor () {
        super();
        this.control = this.querySelector('#includeToCart');
        this.originalFetch = window.fetch.bind(window);
        this.params = null;
        this.cartSections = {};
        this.modalOpener = this.querySelector('modal-opener button');
        try {
          let params = this.querySelector('[type="application/json"]');
          if (params) {
            this.params = JSON.parse(params.textContent);
          }
        } catch (e) {
          console.error(e.message);
        }
        if (this.control && this.params) {
          this.catchRequest();
        }
      }

      catchRequest () {
        window.fetch = async (input, init) => {
          if (init && init.method === 'POST') {
            if (init.body && typeof init.body === 'object') {
              if (input.includes(routes.cart_add_url)) {
                const data = await this.prepareData(init.body);
                if (data !== null) {
                  let formData = new FormData();
                  for (let field in data) {
                    if (data.hasOwnProperty(field)) {
                      if (field === 'items') {
                        data.items.forEach((item, index) => {
                          for (let field in item) {
                            formData.append(`items[${index}][${field}]`, item[field]);
                          }
                        });
                      } else {
                        formData.append(field, data[field]);
                      }
                    }
                  }
                  init.body = formData;
                }
              }
            }
          }
          return this.originalFetch(input, init);
        };

      }

      async prepareData (formData) {
        const variantID = formData.get('id') * 1;
        const productID = formData.get('product-id') * 1;
        if (this.control.checked
          && this.params?.mainProduct?.id
          && this.params.mainProduct.id === productID
          && this.params?.upsellSelectedVariant?.id) {
          const quantity = formData.get('quantity') === null ? 1 : formData.get('quantity') * 1;
          this.cartSections = {
            'section-id': formData.get('section-id'),
            'sections': formData.get('sections'),
            'sections_url': formData.get('sections_url'),
          };
          const mainItem = {
            'id': variantID,
            'quantity': quantity,
          };
          const upsellItem = {
            'id': this.params.upsellSelectedVariant?.id,
            'quantity': 1,
          };
          if (this.params?.discountCode) {
            upsellItem['properties[_upsell_for]'] = variantID;
            upsellItem['properties[_upsell_discount_code]'] = this.params?.discountCode;
          }
          return {
            'items': [
              mainItem,
              upsellItem,
            ],
            ...this.cartSections,
          };
        }
        return null;
      };

      linkClickHandle (e) {
           e.preventDefault();
           this.querySelector('modal-opener');
           if(this.modalOpener) {
             this.modalOpener.dispatchEvent(new Event('click'));
           }
      }

      connectedCallback () {
        this.querySelectorAll('a').forEach((item)=>{
          item.addEventListener('click', this.linkClickHandle.bind(this));
        });
      }

      disconnectedCallback () {
        this.querySelectorAll('a').forEach((item)=>{
          item.removeEventListener('click', this.linkClickHandle.bind(this));
        });
      }
    },
  );
}